import React, { Component } from "react";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import axios from "axios";

import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import {
  NewInputText,
  PasswordReusableInput,
} from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

import { SliderReusableComponent } from "../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BottomTextAndLink } from "../../reusableComponents/smallReusableComponent/BottomTextAndLink";
import {
  BackLogoIconButton,
  LoginTopLogoAndText,
} from "../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import InputNumberFunc from "../../../function/InputNumberFunc";
import { FormHelperText } from "@material-ui/core";

//import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { create_new_user } from "../../../store/actions/authAction";
import { SignupValidation } from "../../../store/validation/allValidationFile/authenticationValidation/SignupValidation";
import isEmpty from "../../../store/validation/is-Empty";
import { TermsAndConditionTab } from "./TermsAndConditionTab";
import Media from "react-media";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

const strongRegex = new RegExp(
  /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,32}$/
);

export class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayTab: false,
      country_code: "",
      country: "",
      number: "",
      email: "",
      password: "",
      confirm_password: "",
      referral_code: "",
      role: "vendor",
      view: false,
      viewConfirm: false,
      passwordIcon: true,
      slashEyeIcon: false,
      errors: {},
      error: null,
      isLoading: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.props.clear_all_errors();

    const queryParams = new URLSearchParams(window.location.search);
    const referralCode = queryParams.get("referralCode");
    this.setState({ isLoading: true, errors: {}, referral_code: referralCode });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        this.setState({
          country_code: result.data.country_calling_code,
          country: result.data.country_code,
          isLoading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      Object.keys(nextProps.errors).length > 0 &&
      nextProps.errors !== nextState.errors
    ) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.auth.loader !== nextState.loading) {
      return {
        loading: nextProps.auth.loader,
      };
    }
    return null;
  }

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleOnChange = (value) => {
    this.setState(
      {
        country_code: "+" + value,
        // errors: {}
      },
      () => {}
    );
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      // errors: {},
    });
    // this.props.clear_all_errors();
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else if (
      e.target.name === "email" &&
      !validEmailRegex.test(e.target.value)
    ) {
      errors[e.target.name] = `A valid email is required!`;
    }
    //  else if (e.target.name === "password" && e.target.value.length < 6) {
    //   errors[e.target.name] = `Please enter a valid password`;
    // }
    else if (
      e.target.name === "password" &&
      !strongRegex.test(e.target.value)
    ) {
      errors[
        e.target.name
      ] = `Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters.`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "email":
        errors.email = validEmailRegex.test(value)
          ? ""
          : "Enter Valid Email Address";
        break;
      // case "password":
      //   errors.password =
      //     value.length < 6 ? "Password must contain atleast 6 characters" : "";
      //   break;
      case "password":
        errors.password = strongRegex.test(value)
          ? ""
          : "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters.";
        break;

      case "confirm_password":
        errors.confirm_password =
          value.length < 6
            ? "Confirm password must contain atleast 6 characters"
            : "";
        break;
      default:
        break;
    }

    this.setState({ errors, [name]: value });
  };

  handleClickShowPassword = (e) => {
    this.setState({
      view: !this.state.view,
    });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleClickConfirmPassword = (e) => {
    this.setState({
      viewConfirm: !this.state.viewConfirm,
    });
  };

  handleMouseConfirmPassword = (event) => {
    event.preventDefault();
  };

  onPasswordChange = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: false,
      slashEyeIcon: true,
    });
  };

  onPasswordHide = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: true,
      slashEyeIcon: false,
    });
  };

  onClickTermsAndConditions = (e) => {
    this.setState({
      displayTab: !this.state.displayTab,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = SignupValidation(this.state);
    if (!isValid) {
      this.setState({
        errors: errors,
      });
    } else {
      const formData = {
        country_code: this.state.country_code,
        country: this.state.country,
        // mobile_number: this.state.country_code + this.state.number,
        mobile_number: this.state.number,
        email: this.state.email,
        password: this.state.password,
        confirm_password: this.state.confirm_password,
        referral_code: this.state.referral_code,
        role: this.state.role,
      };
      this.props.create_new_user(formData, this.props.history);
    }
  };

  render() {
    const {
      displayTab,
      number,
      email,
      password,
      confirm_password,
      loading,
      errors,
    } = this.state;

    if (loading) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Container fluid className="loginsignup-main">
          <Row>
            {/* <BackButtonIcon linkPath="/" /> */}
            <Col
              id={displayTab ? "loginsignup-leftside-scroll" : null}
              className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 loginsignup-leftside "
            >
              {/* loginsignup-leftside-height */}
              {displayTab === false ? (
                <div>
                  <div className="col-12 display-top-header-mobile display-in-mobile">
                    <BackLogoIconButton
                      displayHelpImage={true}
                      backButtonClicked="/"
                      notDisplaProgressBar={true}
                    />
                  </div>
                  <div className="col-12 loginsignup-section">
                    <LoginTopLogoAndText
                      bigText="Sign Up"
                      linkTextBig="Have an account?"
                      linkSmall="Login"
                      redirectLink="/"
                    />
                  </div>
                  <Col className="login-section-margin">
                    <Form noValidate onSubmit={this.handleSubmit}>
                      <Form.Row className="input-component-insideRow">
                        <div className="col-3 ">
                          <Form.Group
                            className="reusableInputComponent-main mb-0"
                            controlId={"country_code"}
                          >
                            <div className="input-phone-country-code-reusable w-100">
                              <select
                                className="w-100"
                                name="country_code"
                                value={this.state.country_code}
                                onChange={this.onChange}
                              >
                                <option value={this.state.country_code}>
                                  {this.state.country_code}
                                </option>
                                {getCountries().map((country) => (
                                  <option
                                    key={country}
                                    value={"+" + getCountryCallingCode(country)}
                                  >
                                    {en[country]} (+
                                    {getCountryCallingCode(country)})
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Form.Group>
                        </div>
                        <div className="col-9 pl-0">
                          <NewInputText
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            extraClass="mb-0"
                            name="number"
                            inputType="number"
                            onFocusOut={this.onFocusOut}
                            autoFocus={true}
                            onChange={this.onChange}
                            onKeyDown={InputNumberFunc}
                            value={this.state.number}
                            maxLength="10"
                            errorText={
                              this.state.number.length > 0 &&
                              this.state.number.length <= 9
                                ? "Enter valid Mobile Number"
                                : null || errors.number === "number is required"
                                ? "mobile number is required"
                                : null
                            }
                            errorTrue={
                              (this.state.number.length > 0 &&
                                this.state.number.length <= 9) ||
                              errors.number === "number is required"
                                ? true
                                : false
                            }
                            labelText="Phone Number"
                            controlClass={
                              (this.state.number.length > 0 &&
                                this.state.number.length <= 9) ||
                              errors.number === "number is required"
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                      </Form.Row>
                      <NewInputText
                        extraClass="mb-0 mt-4"
                        name="email"
                        inputType="email"
                        onFocusOut={this.onFocusOut}
                        onChange={this.handleChange}
                        value={this.state.email}
                        errorText={
                          !validEmailRegex.test(email) && !isEmpty(email)
                            ? "Please enter a valid email"
                            : null || errors.email === "email is required"
                            ? "email is required"
                            : ""
                        }
                        errorTrue={
                          (!validEmailRegex.test(email) && !isEmpty(email)) ||
                          errors.email === "email is required"
                            ? true
                            : false
                        }
                        labelText="E-mail Address"
                        controlClass={
                          (!validEmailRegex.test(email) && !isEmpty(email)) ||
                          errors.email === "email is required"
                            ? "outlined-error-helper-text"
                            : "outlined-helperText"
                        }
                      />
                      <PasswordReusableInput
                        onKeyPress={(event) => {
                          if (!/^\S*$/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        extraClass="mt-4 w-100"
                        labelText="Enter Password"
                        inputTypeState={this.state.view}
                        value={this.state.password}
                        name="password"
                        onFocusOut={this.onFocusOut}
                        handleChange={this.handleChange}
                        handleClickShowPassword={this.handleClickShowPassword}
                        handleMouseDownPassword={this.handleMouseDownPassword}
                        errorText={
                          errors.password
                          // this.state.password.length > 0 &&
                          // this.state.password.length < 6
                          //   ? "Password Minimum 6 characters Long or Maximum 32 Characters"
                          //   : errors.password === "password is required"
                          //   ? errors.password
                          //   : errors.password ===
                          //     "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                          //   ? "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                          //   : null
                        }
                        errorTrue={
                          errors.password === "password is Required" ||
                          errors.password === "password is required" ||
                          errors.password ===
                            "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                            ? // (this.state.password.length > 0 &&
                              //   this.state.password.length < 6)
                              true
                            : false
                        }
                        wLabel={120}
                      />
                      <PasswordReusableInput
                        onKeyPress={(event) => {
                          if (!/^\S*$/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        extraClass="mt-4 w-100"
                        labelText="Confirm Password"
                        inputTypeState={this.state.viewConfirm}
                        value={this.state.confirm_password}
                        name="confirm_password"
                        onFocusOut={this.onFocusOut}
                        handleChange={this.handleChange}
                        handleClickShowPassword={
                          this.handleClickConfirmPassword
                        }
                        handleMouseDownPassword={
                          this.handleMouseConfirmPassword
                        }
                        errorText={
                          this.state.confirm_password.length === 0
                            ? errors.confirm_password
                            : "Password and Confirm Password do not match" &&
                              this.state.password !==
                                this.state.confirm_password
                            ? "Password and Confirm Password do not match"
                            : ""
                        }
                        errorTrue={
                          this.state.confirm_password.length === 0
                            ? errors.confirm_password
                            : "Password and Confirm Password do not match" &&
                              this.state.password !==
                                this.state.confirm_password
                        }
                        wLabel={140}
                      />
                      <NewInputText
                        // onKeyPress={(event) => {
                        //   if (!/[0-9]/.test(event.key)) {
                        //     event.preventDefault();
                        //   }
                        // }}
                        extraClass="mb-4 mt-4"
                        name="referral_code"
                        inputType="text"
                        onFocusOut={this.onFocusOut}
                        onChange={this.onChange}
                        // onKeyDown={InputNumberFunc}
                        value={this.state.referral_code}
                        maxLength={12}
                        errorText={errors.code === 401 ? errors.message : ""}
                        errorTrue={errors.code === 401 ? true : false}
                        controlClass={
                          errors.code === 401
                            ? "outlined-error-helper-text"
                            : "outlined-helperText"
                        }
                        labelText="Referral Code"
                      />
                      {errors.code === 409 ? (
                        <div className="mb-4">
                          <FormHelperText
                            id="outlined-error-helper-text"
                            style={{ color: "#f44336" }}
                          >
                            Phone number / Email already exists
                          </FormHelperText>
                        </div>
                      ) : null}
                      <div
                        className="font_14_r d-flex mb-4"
                        style={{ color: "#464646", cursor: "pointer" }}
                        onClick={this.onClickTermsAndConditions}
                      >
                        By signing up, I accept the
                        <div className="c_blue">
                          &nbsp;Terms and Conditions.
                        </div>
                      </div>
                      <ButtonReusableComponent
                        buttonText="Sign Up"
                        buttonType={
                          number.length <= 9 ||
                          password.length < 6 ||
                          confirm_password.length < 6 ||
                          password !== confirm_password ||
                          email === "" ||
                          errors.email === "Enter Valid Email Address" ||
                          errors.password ===
                            "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                            ? "button"
                            : "submit"
                        }
                        buttonClass={
                          number.length <= 9 ||
                          password.length < 6 ||
                          confirm_password.length < 6 ||
                          password !== confirm_password ||
                          email === "" ||
                          errors.email === "Enter Valid Email Address" ||
                          errors.password ===
                            "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                            ? "login"
                            : "activeLogin"
                        }
                        disabled={
                          number.length <= 9 ||
                          password.length < 6 ||
                          confirm_password.length < 6 ||
                          password !== confirm_password ||
                          email === "" ||
                          errors.email === "Enter Valid Email Address" ||
                          errors.password ===
                            "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                            ? true
                            : false
                        }
                        // this.state.email.length > 0 && errors.email
                      />
                    </Form>
                    {/* <div className="col-12 mobile">
                      <LoginTopLogoAndText
                        linkTextBig="Have an account?"
                        linkSmall="Login"
                        redirectLink="/"
                      />
                    </div> */}
                    <Media query="(max-width: 991px)">
                      <div className="mt-3 mb-3">
                        <BottomTextAndLink
                          textCss="login-bottom-text-red mt-4"
                          text="Already have an account?"
                          linkText="Login"
                          link="/"
                          linkTextColor={true}
                        />
                      </div>
                    </Media>
                  </Col>
                </div>
              ) : (
                <TermsAndConditionTab
                  onClick={this.onClickTermsAndConditions}
                />
              )}
            </Col>
            <Col className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={
                  require("../../../assets/images/illustratorImage/Amealio_Illustrations-08.png")
                    .default
                }
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

SignUp.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  create_new_user,
  clear_all_errors,
})(withRouter(SignUp));
